import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CommercialOfferResult, LoanSimulation } from '../eDniModal/eDniModalInterface';
import { OrderDetailsResponseContent } from './orderManagedInterface';

export interface OrderData {
  data: OrderDetailsResponseContent;
}

interface OrderState {
  data: OrderData | null;
  simulationsManaged: LoanSimulation[] | null;
  simulationTerm: number;
  isPreferredOffer: boolean;

}

const initialState: OrderState = {
  data: null,
  simulationsManaged: null,
  simulationTerm: 0,
  isPreferredOffer: false,
};

export const orderSlice = createSlice({
  name: 'orderManaged',
  initialState,
  reducers: {
    saveOrderManagedData: (state, action: PayloadAction<OrderData>) => {
      state.data = action.payload;
    },
    clearOrderManagedData: (state) => {
      state.data = null;
    },
    saveBudgetSimulations: (state, action: PayloadAction<LoanSimulation[]>) => {
      state.simulationsManaged = action.payload;
    },
    clearBudgetSimulations: (state) => {
      state.simulationsManaged = null;
    },
    saveSimulationTerm: (state, action: PayloadAction<number>) => {
      state.simulationTerm = action.payload;
    },
    clearSimulationTerm: (state) => {
      state.simulationTerm = 0;
    },
    saveIsPreferredOffer: (state, action: PayloadAction<boolean>) => {
      state.isPreferredOffer = action.payload;
    },
    clearIsPreferredOffer: (state) => {
      state.isPreferredOffer = false;
    },
  },
});

export const {
  saveOrderManagedData,
  clearOrderManagedData,
  saveBudgetSimulations,
  clearBudgetSimulations,
  saveSimulationTerm,
  clearSimulationTerm,
  saveIsPreferredOffer,
  clearIsPreferredOffer,
} = orderSlice.actions;

export default orderSlice.reducer;
